export const PORTAL_URL = window.location.origin; // eslint-disable-line

// Portal routes
export const LOGIN_URL = '/login';
export const SIGNUP_URL = '/signup';

export const ROOT_URL = '/';
export const RESTAURANT_URL = '/restaurant';
export const RESTAURANT_MEAL_SCHEDULE_URL = '/restaurant/meal-schedule';
export const RESTAURANT_ORDERS_URL = '/restaurant/orders';
export const RESTAURANT_ORDERS_LIST_URL = '/restaurant/orders/list';
export const RESTAURANT_REPORTS_URL = '/restaurant/reports';
export const RESTAURANT_MEALS = '/restaurant/meals';
export const EMPLOYEES_LIST_URL = '/company/employees';
export const COMPANY_REPORTS_URL = '/company/reports';
export const GET_COMPANY_VENDORS = "/company/vendors";
export const COMPANY_MANAGE_CREDITS_URL = '/company/manage-credits';
export const COMPANY_EDIT_PROFILE_URL = '/profile/company-edit';
export const MY_ORDERS_URL = '/orders';
export const PROFILE_EDIT_PREFIX_URL = '/profile';

export const COMPANY_URL = '/company';
export const EMPLOYEES_MEALS_URL = '/employee/order/meals';
export const EMPLOYEE_ORDER_HISTORY = '/employee/report';
export const EMPLOYEE_TODAYS_ORDERS = '/employee/order/placed';
export const EMPLOYEE_ORDER_URL = '/employee/order';
export const EMPLOYEE_ROUTES_PREFIX = '/employee';
export const EMPLOYEE_EDIT_PROFILE_URL = '/profile/employee-edit';
export const RESET_PASSWORD_UI_URL = '/reset_password';

export const COMPANY_ORDER_HISTORY = '/company/orders';
/** Superadmin pages */
export const ADMIN_PREFIX = '/admin';
export const COMPANIES_URL = '/admin/companies';
export const CREATE_NEW_COMPANY = '/admin/companies/new';
export const EDIT_COMPANY_DETAILS = '/admin/companies/:id/edit';
export const RESTAURANTS_URL = '/admin/restaurants';
export const CREATE_NEW_RESTAURANT = '/admin/restaurants/new';
export const EDIT_RESTAURANT_DETAILS = '/admin/restaurants/:id/edit';
export const COMPANY_RESTAURANTS_MAPPING = `${COMPANIES_URL}/:id/mapping`;
export const RESTAURANT_MEALS_URL = '/admin/restaurants/:id/meals';
export const ADMIN_RESTAURANT_MEAL_SCHEDULE_URL = '/admin/restaurants/:id/schedules';
// API routes
export const GET_RESTAURANT_SCHEDULES = '/restaurants/:id/schedules';
export const GET_RESTAURANT_ORDER = '/restaurants/:id/home';
export const UPDATE_RESTAURANT_SERVICE_STATUS = '/restaurants/:id/service_status';
export const GET_COMPANY_WISE_RESTAURANT_ORDERS = '/restaurants/:id/company_wise_orders';
export const GET_RESTAURANT_REPORTS = '/restaurants/:id/report';
export const UPDATE_COMPANY_ORDER_STATUS = '/order_batches/:id/:status';
export const GET_MEAL_DETAILS = '/meals/:id';

export const GET_MEALS = 'restaurants/:id/meals';
export const UPDATE_MEAL = '/restaurants/:restaurant_id/meals/:meal_id/update_meal';
export const UPDATE_MEAL_ITEM = '/meals/:id';
export const ADD_RESTAURANT_MEAL = '/restaurants/:id/meals';
export const GET_ORDERS_URL = '/orders/search';
export const GET_EMPLOYEES_LIST = '/companies/:company_id/users/search';
export const ADD_NEW_EMPLOYEE = '/companies/:company_id/users';
export const UPDATE_EMPLOYEE_DETAILS = '/companies/:company_id/users/:id';
export const GET_COMPANY_HOME_DETAILS = '/companies/:id/home';
export const BULK_UPLOAD_URL = '/uploads';
export const LATEST_UPLOAD_URL = '/uploads/latest';
export const GET_COMPANY_REPORTS = '/companies/:id/report';
export const GET_EMPLOYEE_HOME_DETAILS = '/employees/:id/home';
export const EMPLOYEE_PLACE_ORDER = '/orders';
export const EMPLOYEE_CANCEL_ORDER = '/orders/:id/cancel';
export const EMPLOYEE_UPDATE_PROFILE = '/employees/:id';
export const UPDATE_COMPANY = '/companies/:id';
export const GET_COMPANIES = '/companies/search';
export const GET_CUISINES_LIST = '/cuisines/search';
export const GET_RESTAURANT_DETAILS = '/restaurants/:id';

export const ADD_NEW_COMPANY = '/companies';
export const GET_RESTAURANTS = '/restaurants/search';
export const ADD_NEW_RESTAURANT = '/restaurants';
export const UPDATE_RESTAURANT = '/restaurants/:id';
export const DELETE_RESTAURANT = '/restaurants/:id';
export const DELETE_COMPANY = '/companies/:id';
export const FORGOT_PASSWORD_URL = '/forgot_password';
export const RESET_PASSWORD_URL = '/reset_password';
export const CHANGE_PASSWORD_URL = '/users/:id/change_password';
export const GET_COMPANY_RESTAURANTS_MAPPINGS = '/companies/:id/company_cuisine_restaurants';
export const UPDATE_COMPANY_RESTAURANTS_MAPPING = '/companies/:id/company_cuisine_restaurants';
export const DELETE_EMPLOYEE = '/companies/:company_id/users/:id';
export const GET_RESTAURANT_MEALS = 'meals';
export const CREATE_MEAL_SCHEDULES = '/restaurants/:id/schedules';
